__turbopack_context__.v({
  "button": "sierrachatbutton-module-scss-module__HfCXBa__button",
  "dismissButton": "sierrachatbutton-module-scss-module__HfCXBa__dismissButton",
  "dismissIcon": "sierrachatbutton-module-scss-module__HfCXBa__dismissIcon",
  "proactiveBanner": "sierrachatbutton-module-scss-module__HfCXBa__proactiveBanner",
  "proactiveBannerButton": "sierrachatbutton-module-scss-module__HfCXBa__proactiveBannerButton",
  "proactiveBannerWrapper": "sierrachatbutton-module-scss-module__HfCXBa__proactiveBannerWrapper",
});
